module.exports = __webpack_public_path__ + "static/media/mgm_hero.7726c931.png";